export interface TeamMember {
  id: string;
  name: string;
  email: string;
  role: string;
  skills: string[];
  department: string;
  avatar?: string;
}

export interface Team {
  id: string;
  name: string;
  description?: string;
  leaderId: string;
  members: string[]; // array of member IDs
  createdAt: string;
  updatedAt: string;
}

export interface TeamWithMembers extends Omit<Team, 'members'> {
  leader: TeamMember;
  members: TeamMember[];
}

// Team roles
export type TeamRole = 'Leader' | 'Member' | 'Observer';

// Mock data
export const mockTeamMembers: TeamMember[] = [
  {
    id: '1',
    name: 'John Smith',
    email: 'john.smith@company.com',
    role: 'Senior Developer',
    skills: ['React', 'TypeScript', 'Node.js'],
    department: 'APPS'
  },
  {
    id: '2',
    name: 'Emma Johnson',
    email: 'emma.johnson@company.com',
    role: 'UX Designer',
    skills: ['UI/UX', 'Figma', 'User Research'],
    department: 'DPS'
  },
  {
    id: '3',
    name: 'Michael Brown',
    email: 'michael.brown@company.com',
    role: 'Project Manager',
    skills: ['Scrum', 'JIRA', 'Risk Management'],
    department: 'APPS'
  },
  {
    id: '4',
    name: 'Sarah Davis',
    email: 'sarah.davis@company.com',
    role: 'Backend Developer',
    skills: ['Java', 'Spring Boot', 'PostgreSQL'],
    department: 'APPS'
  },
  {
    id: '5',
    name: 'David Wilson',
    email: 'david.wilson@company.com',
    role: 'DevOps Engineer',
    skills: ['Docker', 'Kubernetes', 'AWS'],
    department: 'DPS'
  }
];

export const mockTeams: Team[] = [
  {
    id: '1',
    name: 'Frontend Development',
    description: 'Responsible for all frontend development tasks and UI implementation',
    leaderId: '1',
    members: ['1', '2', '4'],
    createdAt: '2023-10-15',
    updatedAt: '2024-03-20'
  },
  {
    id: '2',
    name: 'Project Management',
    description: 'Oversees project planning, execution, and delivery',
    leaderId: '3',
    members: ['3', '5'],
    createdAt: '2023-11-05',
    updatedAt: '2024-02-10'
  }
]; 
